// import { useEffect, useState } from "react";
import {  useSelector } from "react-redux";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import dynamic from "next/dynamic";
import Box from "@mui/material/Box";
import useWindowSize from "../../_hooks/useWindowSize";
// import CardHeader from '@mui/material/CardHeader';
// import Input from '@mui/material/Input';
// import InputUnstyled from '@mui/base/InputUnstyled';

// import Image from "next/image";

const MaintenancePage = dynamic(() => import('../Portal/MaintenancePage'))
const CardHeader = dynamic(() => import('./CardHeader'))

const CardContainer = ({children,title="", sx={}, cardMinWidth = '35em', className = "", styles = {}}) => {
    const {template_settings} = useSelector(state => state.globalReducer);
    const {isMobile}= useWindowSize()
    // console.log(process.env.brand.acronym)
    return (
        template_settings.portal_maintenance && template_settings.portal_maintenance == 'false' ? (
            <Box 
                className={className}
                style={{  
                    display: 'flex',
                    minHeight: !isMobile ? title  == 'Register' ? '90vh' : '75vh' :  title == 'Register' ?  '90vh' : '75vh',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: '#f0f2f5',
                    ...styles,
                }}
            >
                <Box sx={{flexDirection:'row'}}>
                    <Box>
                    </Box>
                    <Box>
                        <Card
                            elevation={0} 
                            sx={{
                                border: '1px solid',
                                borderColor: (theme) => theme.palette.grey[400],
                                maxWidth: '38em',
                                minHeight: '30em',
                                margin: {
                                    xs: '8px',
                                    md: 0
                                },
                                borderRadius:2,
                                minWidth: {
                                    xs: '24em',
                                    md: cardMinWidth,
                                },
                                ...sx,
                            }}
                            >
                            <CardHeader title={title} sx={{color: 'primary.main'}}/>
                            <CardContent 
                                sx={{
                                    padding: {
                                        xs: '0px 20px 0px 20px',
                                        md: '0px 40px 0px 40px'
                                    }
                                }}
                            >
                                {children}
                            </CardContent>
                        </Card>
                    </Box>
                </Box>
            </Box>
        ) : <MaintenancePage />
    )
}

export default CardContainer